<template>
  <div id="app">
      <UiGuide/>
  </div>
</template>

<script>
import UiGuide from './components/ui-guide.vue';

export default {
  name: 'App',
  components: {
     UiGuide
  }
}
</script>

<style lang="scss">
  @import '@/design/index.scss';
</style>

